import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Meetings",
  "Galas",
  "Conferences",
  "Association Management",
  "Hybrid Broadcasts",
  "Sponsorships",
  "Global Logistics",
  "Registration",
];

export default function EditorialMarquee() {
  return (
    <section
      aria-label="Capabilities marquee"
      className="border-y border-[var(--border)] py-8 md:py-10 bg-white marquee-fade"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {items.concat(items).map((item, i) => (
          <span
            key={i}
            className="font-editorial text-4xl md:text-6xl lg:text-7xl text-[var(--text)] mx-10 tracking-tight flex items-center"
          >
            {item}
            <span className="mx-6 w-2 h-2 rounded-full bg-gradient-to-r from-cyan-400 to-sky-500 inline-block" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
